import { gql, useQuery } from '@apollo/client';
import { useContext } from 'react';
import { Box } from '@zillow/constellation-10';
import { InboxPageContext } from '../../contexts/InboxPageContextProvider';
import { AppContext } from '../../contexts/AppContextProvider';
import Attachments from './components/Attachments';
import EmptyContainer from './components/EmptyContainer';
import ExpiredRenterProfile from './components/ExpiredRenterProfile';
import Header from './components/Header';
import NextStep from './components/NextStep';
import NoteSection from './components/NoteSection';
import RenterProfileAttributes from './components/RenterProfileAttributes';
import Skeleton from './skeleton';

export default function InboxSidebar(): JSX.Element | null {
  const { conversationId } = useContext(InboxPageContext);
  const { hasMessageListError } = useContext(AppContext);
  const { data: inboxPageVariables } = useQuery(GET_INBOX_PAGE_VARIABLES, { fetchPolicy: 'cache-only' });
  const { inboxPageShowEmptyContainer, inboxPageIsLoading } = inboxPageVariables;
  const shouldShowEmptyContainer = !conversationId || inboxPageShowEmptyContainer || hasMessageListError;

  if (inboxPageIsLoading) {
    return <Skeleton />;
  } else if (shouldShowEmptyContainer) {
    return <EmptyContainer />;
  }

  return (
    <Box css={{ overflowY: 'auto', paddingInline: 'default', paddingBlock: 'loose' }} data-testid="inbox-sidebar">
      <Header />
      <NoteSection />
      <NextStep />
      <RenterProfileAttributes />
      <ExpiredRenterProfile />
      <Attachments />
    </Box>
  );
}

const GET_INBOX_PAGE_VARIABLES = gql`
  query {
    inboxPageShowEmptyContainer @client
    inboxPageIsLoading @client
  }
`;
